/**
 * 请求参数签名
 */

import crypto from 'crypto-js';

const getParams = (params) => {
  var keys = Object.keys(params).sort();
  var list = [];
  for (var i = 0; i < keys.length; i++) {
    var value = params[keys[i]];
    // if (!value) {
    //     continue;
    // }
    let p = keys[i] + '=' + encodeURIComponent(value);
    p = p.replace(/\(/g, '%28');
    p = p.replace(/\)/g, '%29');
    p = p.replace(/\+/g, '%20');
    p = p.replace(/\\!/g, '%21');
    p = p.replace(/\\~/g, '%7E');
    p = p.replace(/\*/g, '%2A');
    list.push(p);
  }
  return list.join('&');
};

export const sign = (params, server, key) => {
  var baseString =
    encodeURIComponent(server) + encodeURIComponent(getParams(params));
  const hash = crypto.HmacSHA1(baseString, key);
  return hash.toString(crypto.enc.Base64);
};
